(function() {
  function initBannerMarquee() {
    const scrollContainer = document.querySelector(".sp-scroll2");
    if (!scrollContainer) {
      console.warn("Banner marquee container not found");
      return;
    }
    const navImgs = scrollContainer.querySelector(".nav-imgs");
    const flexX = scrollContainer.querySelector(".sp-flex-x");
    if (!navImgs || !flexX) {
      console.warn("Banner marquee elements not found");
      return;
    }
    const clone = flexX.cloneNode(true);
    navImgs.appendChild(clone);
    let scrollLeft = 0;
    const scrollSpeed = 0.5;
    const contentWidth = flexX.offsetWidth;
    function scroll() {
      scrollLeft += scrollSpeed;
      if (scrollLeft >= contentWidth) {
        scrollLeft = 0;
      }
      navImgs.style.transform = `translateX(-${scrollLeft}px)`;
      requestAnimationFrame(scroll);
    }
    requestAnimationFrame(scroll);
    console.log("Banner marquee initialized");
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBannerMarquee);
  } else {
    initBannerMarquee();
  }
})();
(function() {
  function initFAQ() {
    console.log("FAQ: Starting initialization...");
    const faqItems = document.querySelectorAll(".faq-item");
    console.log("FAQ: Found", faqItems.length, "items");
    if (faqItems.length === 0) {
      console.warn("FAQ items not found");
      return;
    }
    faqItems.forEach((item, index) => {
      const question = item.querySelector(".faq-question");
      if (!question) {
        console.warn(`FAQ item ${index + 1}: question element not found`);
        return;
      }
      if (question._faqInitialized) {
        console.warn(`FAQ item ${index + 1} already initialized`);
        return;
      }
      question._faqInitialized = true;
      console.log(`FAQ: Setting up item ${index + 1}`);
      question.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        console.log(`FAQ: Item ${index + 1} clicked`);
        const isActive = item.classList.contains("active");
        if (isActive) {
          item.classList.remove("active");
          question.setAttribute("aria-expanded", "false");
          console.log(`FAQ item ${index + 1} collapsed`);
        } else {
          item.classList.add("active");
          question.setAttribute("aria-expanded", "true");
          console.log(`FAQ item ${index + 1} expanded`);
        }
      }, { capture: true });
      question.setAttribute("role", "button");
      question.setAttribute("aria-expanded", "false");
      question.setAttribute("tabindex", "0");
      question.addEventListener("keydown", function(e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          question.click();
        }
      });
    });
    console.log(`FAQ initialized successfully with ${faqItems.length} items`);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      console.log("FAQ: DOM loaded via DOMContentLoaded");
      try {
        initFAQ();
      } catch (error) {
        console.error("Error initializing FAQ:", error);
      }
    });
  } else {
    console.log("FAQ: DOM already loaded");
    try {
      initFAQ();
    } catch (error) {
      console.error("Error initializing FAQ:", error);
    }
  }
})();
(function($) {
  $(function() {
    console.log("===== Header.js loaded - Version 2.0 =====");
    function initAnchorLinks() {
      $(document).on("click", 'a[href^="#"]', function(e) {
        e.preventDefault();
        const targetId = $(this).attr("href");
        if (targetId === "#" || targetId === "") {
          return;
        }
        console.log("Clicking anchor link to:", targetId);
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          console.log("Target element found, scrolling...");
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
          console.log("Scroll initiated to:", targetId);
        } else {
          console.warn("Target not found:", targetId);
        }
      });
      console.log("Anchor links initialized with event delegation (using scrollIntoView)");
    }
    function initHeaderSwiper() {
      if (typeof Swiper === "undefined") {
        return;
      }
      const headerSwiperEl = document.querySelector(".header-swiper");
      if (!headerSwiperEl) {
        return;
      }
      const headerSwiper = new Swiper(".header-swiper", {
        // 自动播放
        autoplay: {
          delay: 3e3,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
          // 鼠标悬停时暂停
        },
        // 循环模式
        loop: true,
        // 切换效果
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        // 速度
        speed: 800,
        // 允许触摸滑动
        allowTouchMove: false,
        // 事件回调
        on: {
          init: function() {
          }
        }
      });
      return headerSwiper;
    }
    try {
      initHeaderSwiper();
      initAnchorLinks();
    } catch (error) {
      console.error("Error initializing header swiper:", error);
    }
  });
})(jQuery);

(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
(function($) {
  $(function() {
    console.log("Part3 carousel initialized");
    function initSingleCarousel(carouselElement) {
      const container = carouselElement.querySelector(".part3-carousel-container");
      const track = carouselElement.querySelector(".part3-carousel-track");
      const prevBtn = carouselElement.querySelector(".part3-carousel-prev");
      const nextBtn = carouselElement.querySelector(".part3-carousel-next");
      const items = carouselElement.querySelectorAll(".part3-carousel-item");
      if (!container || !track || !prevBtn || !nextBtn || items.length === 0) {
        console.warn("Part3 carousel elements not found in:", carouselElement);
        return;
      }
      const isMobile = () => window.innerWidth <= 1080;
      const getVisibleCount = () => isMobile() ? 3 : 5;
      const getItemWidth = () => {
        const item = items[0];
        const itemWidth = item.offsetWidth;
        const gap = isMobile() ? 75 : 64;
        return itemWidth + gap;
      };
      let currentIndex = 0;
      const totalItems = items.length;
      let autoPlayTimer = null;
      let userInteractionTimer = null;
      const autoPlayInterval = 2e3;
      const userInteractionDelay = 5e3;
      function updateCarousel(isAutoPlay = false) {
        const itemWidth = getItemWidth();
        const offset = -currentIndex * itemWidth;
        track.style.transform = `translateX(${offset}px)`;
        prevBtn.disabled = currentIndex === 0;
        const visibleCount = getVisibleCount();
        nextBtn.disabled = currentIndex >= totalItems - visibleCount;
        prevBtn.style.opacity = prevBtn.disabled ? "0.3" : "1";
        nextBtn.style.opacity = nextBtn.disabled ? "0.3" : "1";
      }
      function autoPlayNext() {
        const visibleCount = getVisibleCount();
        if (currentIndex >= totalItems - visibleCount) {
          currentIndex = 0;
        } else {
          currentIndex++;
        }
        updateCarousel(true);
      }
      function startAutoPlay() {
        stopAutoPlay();
        autoPlayTimer = setInterval(autoPlayNext, autoPlayInterval);
      }
      function stopAutoPlay() {
        if (autoPlayTimer) {
          clearInterval(autoPlayTimer);
          autoPlayTimer = null;
        }
      }
      function handleUserInteraction() {
        stopAutoPlay();
        if (userInteractionTimer) {
          clearTimeout(userInteractionTimer);
        }
        userInteractionTimer = setTimeout(() => {
          startAutoPlay();
        }, userInteractionDelay);
      }
      prevBtn.addEventListener("click", () => {
        if (currentIndex > 0) {
          currentIndex--;
          updateCarousel();
          handleUserInteraction();
        }
      });
      nextBtn.addEventListener("click", () => {
        const visibleCount = getVisibleCount();
        if (currentIndex < totalItems - visibleCount) {
          currentIndex++;
          updateCarousel();
          handleUserInteraction();
        }
      });
      container.addEventListener("mouseenter", () => {
        stopAutoPlay();
      });
      container.addEventListener("mouseleave", () => {
        startAutoPlay();
      });
      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const visibleCount = getVisibleCount();
          if (currentIndex > totalItems - visibleCount) {
            currentIndex = Math.max(0, totalItems - visibleCount);
          }
          updateCarousel();
        }, 200);
      });
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          stopAutoPlay();
        } else {
          startAutoPlay();
        }
      });
      updateCarousel();
      startAutoPlay();
      console.log("Part3 carousel ready with auto-play");
    }
    function initPart3Carousel() {
      const pcCarousel = document.querySelector(".part3-carousel-pc");
      if (pcCarousel) {
        initSingleCarousel(pcCarousel);
      }
      const mobileCarousel = document.querySelector(".part3-carousel-mobile");
      if (mobileCarousel) {
        initSingleCarousel(mobileCarousel);
      }
    }
    try {
      initPart3Carousel();
    } catch (error) {
      console.error("Error initializing part3 carousel:", error);
    }
  });
})(jQuery);
(function($) {
  $(function() {
    console.log("Part4 swiper initialized");
    function initPart4Swiper() {
      const swiperContainer = document.querySelector(".part4-swiper");
      if (!swiperContainer) {
        console.warn("Part4 swiper container not found");
        return;
      }
      const isMobile = () => window.innerWidth <= 1080;
      if (!isMobile()) {
        console.log("Part4 swiper: PC mode, swiper disabled");
        return;
      }
      if (typeof Swiper === "undefined") {
        console.error("Swiper library not loaded");
        return;
      }
      try {
        const swiper = new Swiper(".part4-swiper", {
          // 自动播放
          autoplay: {
            delay: 3e3,
            disableOnInteraction: false,
            // 用户交互后继续自动播放
            pauseOnMouseEnter: true
            // 鼠标悬停时暂停
          },
          // 循环模式
          loop: true,
          // 切换效果
          effect: "slide",
          speed: 800,
          // 分页器
          pagination: {
            el: ".part4-swiper-pagination",
            clickable: true,
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active"
          },
          // 触摸滑动
          touchRatio: 1,
          touchAngle: 45,
          // 防止点击穿透
          preventClicks: true,
          preventClicksPropagation: true,
          // 监听窗口大小变化
          observer: true,
          observeParents: true,
          // 事件回调
          on: {
            init: function() {
              console.log("Part4 swiper initialized successfully");
            },
            slideChange: function() {
              console.log("Part4 swiper slide changed:", this.realIndex);
            }
          }
        });
        let resizeTimer;
        window.addEventListener("resize", () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            if (!isMobile()) {
              if (swiper && swiper.autoplay) {
                swiper.autoplay.stop();
              }
            } else {
              if (swiper && swiper.autoplay) {
                swiper.autoplay.start();
              }
            }
          }, 200);
        });
        document.addEventListener("visibilitychange", () => {
          if (!isMobile()) return;
          if (document.hidden) {
            if (swiper && swiper.autoplay) {
              swiper.autoplay.stop();
            }
          } else {
            if (swiper && swiper.autoplay) {
              swiper.autoplay.start();
            }
          }
        });
        console.log("Part4 swiper ready with auto-play");
      } catch (error) {
        console.error("Error creating Part4 swiper:", error);
      }
    }
    try {
      initPart4Swiper();
    } catch (error) {
      console.error("Error initializing part4 swiper:", error);
    }
  });
})(jQuery);
(function($) {
  $(function() {
    console.log("Part6 swiper initialized");
    if (typeof Swiper === "undefined") {
      console.error("Swiper library not loaded");
      return;
    }
    function initPart6SwiperPC() {
      const swiperContainer = document.querySelector(".part6-swiper");
      if (!swiperContainer) {
        console.warn("Part6 PC swiper container not found");
        return;
      }
      try {
        const swiper = new Swiper(".part6-swiper", {
          // 循环模式
          loop: true,
          // 居中显示
          centeredSlides: true,
          // 每次显示3个
          slidesPerView: 3,
          spaceBetween: 30,
          // 自动播放
          autoplay: {
            delay: 3e3,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          // 切换效果
          effect: "slide",
          speed: 800,
          // 触摸滑动
          touchRatio: 1,
          touchAngle: 45,
          // 监听窗口大小变化
          observer: true,
          observeParents: true,
          // 事件回调
          on: {
            init: function() {
              console.log("Part6 PC swiper initialized successfully");
            },
            slideChange: function() {
              console.log("Part6 PC swiper slide changed:", this.realIndex);
            }
          }
        });
        document.addEventListener("visibilitychange", () => {
          if (document.hidden) {
            if (swiper && swiper.autoplay) {
              swiper.autoplay.stop();
            }
          } else {
            if (swiper && swiper.autoplay) {
              swiper.autoplay.start();
            }
          }
        });
        console.log("Part6 PC swiper ready with auto-play");
      } catch (error) {
        console.error("Error creating Part6 PC swiper:", error);
      }
    }
    function initPart6SwiperMobile() {
      const swiperContainer = document.querySelector(".part6-swiper-mobile");
      if (!swiperContainer) {
        console.warn("Part6 Mobile swiper container not found");
        return;
      }
      try {
        const swiper = new Swiper(".part6-swiper-mobile", {
          // 循环模式
          loop: true,
          // 居中显示当前slide
          centeredSlides: true,
          // 显示1.5个slide，让两边露出一部分
          slidesPerView: 1.5,
          // slide之间的间距
          spaceBetween: 30,
          // 自动播放
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          // 切换速度
          speed: 600,
          // 触摸滑动
          touchRatio: 1,
          // 监听变化
          observer: true,
          observeParents: true,
          // 事件回调
          on: {
            init: function() {
              console.log("Part6 Mobile swiper initialized successfully");
              // 给所有slide添加transition
              this.slides.forEach((slide) => {
                slide.style.transition = 'transform 600ms ease, opacity 600ms ease';
                if (!slide.classList.contains('swiper-slide-active')) {
                  slide.style.transform = 'scale(0.85)';
                  slide.style.opacity = '0.6';
                }
              });
            },
            slideChangeTransitionStart: function() {
              // 切换开始时立即更新样式，让动画同步进行
              this.slides.forEach((slide) => {
                if (slide.classList.contains('swiper-slide-active')) {
                  slide.style.transform = 'scale(1)';
                  slide.style.opacity = '1';
                } else {
                  slide.style.transform = 'scale(0.85)';
                  slide.style.opacity = '0.6';
                }
              });
            },
            slideChange: function() {
              console.log("Part6 Mobile swiper slide changed:", this.realIndex);
            }
          }
        });
        document.addEventListener("visibilitychange", () => {
          if (document.hidden) {
            if (swiper && swiper.autoplay) {
              swiper.autoplay.stop();
            }
          } else {
            if (swiper && swiper.autoplay) {
              swiper.autoplay.start();
            }
          }
        });
        console.log("Part6 Mobile swiper ready with auto-play");
      } catch (error) {
        console.error("Error creating Part6 Mobile swiper:", error);
      }
    }
    const isMobile = () => window.innerWidth <= 1080;
    function initPart6Swiper() {
      if (isMobile()) {
        initPart6SwiperMobile();
      } else {
        initPart6SwiperPC();
      }
    }
    try {
      setTimeout(() => {
        initPart6Swiper();
      }, 100);
    } catch (error) {
      console.error("Error initializing part6 swiper:", error);
    }
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        console.log("Part6 swiper: window resized");
      }, 500);
    });
  });
})(jQuery);
(function($) {
  $(function() {
    console.log("Product Cards initialized");
    function initPCCardSelection() {
      const $pcCards = $(".product-cards-pc .product-card");
      console.log("PC Cards found:", $pcCards.length);
      if ($pcCards.length === 0) {
        console.warn("No PC cards found!");
        return;
      }
      if ($pcCards.filter(".card-selected").length === 0) {
        $pcCards.first().addClass("card-selected");
      }
      $pcCards.on("click", function(e) {
        console.log("PC Card clicked!");
        $pcCards.removeClass("card-selected");
        $(this).addClass("card-selected");
      });
      console.log("PC card selection initialized");
    }
    function initMobileCardSelection() {
      const $mobileCards = $(".product-cards-mobile .product-card-m");
      if ($mobileCards.length === 0) return;
      $mobileCards.first().addClass("card-selected-m");
      $mobileCards.on("click", function() {
        $mobileCards.removeClass("card-selected-m");
        $(this).addClass("card-selected-m");
      });
    }
    function getCur(id){
        let prods = window.product
      return prods.find(i=>i.id == id)
    }
    function changePrice(target){
      const id = target.find(".card-region-selector .active").attr("data-id")
      let num = target.find('#calcNumber').val()||1
      let price = (getCur(id).price * Number(num) / 100).toFixed(2)
      let compare = (getCur(id).compare_at_price * Number(num) / 100).toFixed(2)
            console.log(price,'--')
    let off_font = 100 - Math.ceil(getCur(id).price / getCur(id).compare_at_price * 100)
    //   price = (price + '').replace('.', ',')
    //   compare = (compare + '').replace('.', ',')

      target.find('.price-current').html("$"+price)
      target.find('.price-original').html("$"+compare)
      target.find(".sp-count").html(`${off_font}%`)
      target.find('.price-current-m').html("$"+price)
      target.find('.price-original-m').html("$"+compare)
      target.find(".sp-count-m").html(`${off_font}%`)
    }
    function initPCRegionSelector() {
      const $regionBtns = $(".product-cards-pc .region-btn");
      console.log("PC Region buttons found:", $regionBtns.length);
      if ($regionBtns.length === 0) {
        console.warn("No PC region buttons found!");
        return;
      }
      $regionBtns.on("click", function(e) {
        e.stopPropagation();
        console.log("PC Region button clicked!");
        const $card = $(this).closest(".product-card");
        const $btnsInCard = $card.find(".region-btn");
        $btnsInCard.removeClass("region-btn-active");
        $btnsInCard.removeClass("active");
        $(this).addClass("region-btn-active");
        $(this).addClass("active");
        const region = $(this).text();
        changePrice($card)
      });
      console.log("PC region selector initialized");
    }
    $(".card-order-btn,.card-order-btn-m").click(function(){
        const id = $(this).parents(".product-card").find(".card-region-selector .active").attr("data-id")
        const num = $(this).parents(".product-card").find('#calcNumber').val()||1
        window.location.href = '/cart/' + id + ':' + num
    })
      $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
     const $card = $(this).closest(".product-card");
       changePrice($card)
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
 const $card = $(this).closest(".product-card");
   changePrice($card)
  })

    function initMobileRegionSelector() {
      const $regionBtns = $(".product-cards-mobile .region-btn-m");
      if ($regionBtns.length === 0) return;
      $regionBtns.on("click", function(e) {
        e.stopPropagation();
        const $card = $(this).closest(".product-card-m");
        const $btnsInCard = $card.find(".region-btn-m");
        $btnsInCard.removeClass("region-btn-active-m");
        $(this).addClass("region-btn-active-m");
        $btnsInCard.removeClass("active");
        $(this).addClass("active");
        const region = $(this).text();
        changePrice($card)

      });
    }
    function initOrderButtons() {
      $(".card-order-btn, .card-order-btn-m").on("click", function(e) {
        e.stopPropagation();
        const $card = $(this).closest(".product-card, .product-card-m");
        const title = $card.find(".card-title, .card-title-m").text();
        const price = $card.find(".price-current, .price-current-m").text();
        const region = $card.find(".region-btn-active, .region-btn-active-m").text();
        
      });
    }
    try {
      initPCCardSelection();
      initMobileCardSelection();
      initPCRegionSelector();
      initMobileRegionSelector();
      initOrderButtons();
      console.log("Product Cards: All features initialized");
    } catch (error) {
      console.error("Error initializing product cards:", error);
    }
  });
})(jQuery);
(function($) {
  $(function() {
    console.log("Shop script initialized, jQuery version:", $.fn.jquery);
    function getRandomNum(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    }
    let endTimeG;
    function cutDownTime() {
      let nowTime = /* @__PURE__ */ new Date();
      let endTime = new Date(endTimeG);
      let leftTime = endTime.getTime() - nowTime.getTime();
      if (leftTime < 0) {
        setupNewCountdown();
        leftTime = 0;
      }
      let leftH = Math.floor(leftTime / (1e3 * 60 * 60) % 24), leftM = Math.floor(leftTime / (1e3 * 60) % 60), leftS = Math.floor(leftTime / 1e3 % 60);
      leftH = leftH >= 10 ? leftH : "0" + leftH;
      leftM = leftM >= 10 ? leftM : "0" + leftM;
      leftS = leftS >= 10 ? leftS : "0" + leftS;
      return {
        hour: leftH,
        minute: leftM,
        second: leftS
      };
    }
    function setupNewCountdown() {
      const randomHour = getRandomNum(1, 9);
      const currentTime = /* @__PURE__ */ new Date();
      endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
    }
    let intervalId;
    function getCutDownTime() {
      setupNewCountdown();
      if (intervalId) clearInterval(intervalId);
      intervalId = setInterval(function() {
        let cutDownTimeText = cutDownTime();
        $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
        $(".sp_top_cut_down .sp_left_view .sp_minute").html(
          cutDownTimeText.minute
        );
        $(".sp_top_cut_down .sp_left_view .sp_second").html(
          cutDownTimeText.second
        );
      }, 1e3);
    }
    getCutDownTime();
    new Swiper(".sp-swiper-fade-top", {
      spaceBetween: 10,
      effect: "fade",
      autoplay: true,
      autoplay: {
        disableOnInteraction: false,
        delay: 2e3
      },
      speed: 2e3
    });
    new Swiper(".sp-btn-loop", {
      spaceBetween: 10,
      autoplay: true,
      autoplay: {
        disableOnInteraction: false,
        reverseDirection: true
      },
      loop: true
    });
    function mainRender() {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }
      window.addEventListener(
        "resize",
        /* @__PURE__ */ function() {
          var timer;
          return function() {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function() {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        }()
      );
      function lazyLoadImages() {
        const images = document.querySelectorAll(".lazy-load");
        const config = {
          rootMargin: "0px 0px 1300px 0px",
          threshold: 0
        };
        const lazyLoadObserver = new IntersectionObserver(
          function(entries, observer) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                const image = entry.target;
                const dataSrc = image.getAttribute("data-src");
                image.src = dataSrc;
                lazyLoadObserver.unobserve(image);
              }
            });
          },
          config
        );
        images.forEach(function(image) {
          lazyLoadObserver.observe(image);
        });
      }
      lazyLoadImages();
      var links = document.querySelectorAll('a[href^="#shopping"]');
      links.forEach(function(link) {
        link.addEventListener("click", function(event) {
          event.preventDefault();
          const targetElement = document.getElementById("shopping");
          const offsetTop = document.body.clientWidth <= 1080 ? targetElement.offsetTop - $(".sp-nav").height() : targetElement.offsetTop;
          let sptop = document.body.clientWidth <= 1080 ? 70 : 65;
          window.scroll({
            top: offsetTop * $("div#root").css("zoom") - sptop * $("div#root").css("zoom"),
            behavior: "smooth"
            // 使用 smooth 实现平滑滚动
          });
        });
      });
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      var isAndroid = /android/i.test(userAgent);
      var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);
      if (isAndroid) {
        console.log("Android");
      } else if (isIOS) {
        console.log("iOS");
      } else if (isPC) {
        console.log("PC");
      } else {
        $(".sp_system").css("letter-spacing", "-4px");
      }
    }
    mainRender();
   
    const graduallyList = document.getElementsByClassName("gradually");
    for (let gradually of graduallyList) {
      const spans = gradually.querySelectorAll("span");
      const paragraph = gradually.querySelector(".sp-sub-title");
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              spans.forEach((span, index) => {
                span.style.animation = `swift-up-fade 0.5s ease forwards`;
                span.style.animationDelay = `${index * 0.1}s`;
                const i = span.querySelector("i");
                if (i) {
                  i.style.animation = `swift-up-fade 0.5s ease forwards`;
                  i.style.animationDelay = `${index * 0.1}s`;
                }
              });
              const totalDelay = spans.length * 0.1 + 0.3;
              if (paragraph) {
                paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
                paragraph.style.animationDelay = `${totalDelay}s`;
              }
              observer.unobserve(gradually);
            }
          });
        },
        {
          threshold: 0.3
        }
      );
      observer.observe(gradually);
    }
    $(".sp-menu-btn").click(function(e) {
      $(".sp-menu-mask").show();
    });
    $(".sp-menu-mask").click(function(e) {
      $(".sp-menu-mask").hide();
    });
    if ($(window).scrollTop() > $(".sp_header").height() * $("div#root").css("zoom")) {
      $(".sp_header-wrap").addClass("sp-fixed");
    } else {
      $(".sp_header-wrap").removeClass("sp-fixed");
    }
    $(window).scroll(function() {
      if ($(window).scrollTop() > $(".sp_header").height() * $("div#root").css("zoom")) {
        $(".sp_header-wrap").addClass("sp-fixed");
      } else {
        $(".sp_header-wrap").removeClass("sp-fixed");
      }
    });
   
    $(document).on("click", ".sp_add_cart", function() {
      $(this).children("img").addClass("on");
      $(".sp-cart .num").show();
      setTimeout(function() {
        $(" .cart-btn").children("img").removeClass("on");
      }, 500);
      $(" .sp-cart").addClass("on");
      setTimeout(function() {
        $(".sp-cart").removeClass("on");
      }, 500);
      let spNum = $(".sp_product_part #calcNumber")[0].value;
      initNum += Number(spNum);
      $(".cardNum").each(function() {
        $(this).html(initNum);
      });
      $(".cardNum").removeClass("sp-gray");
      var imgs = $(".sp_product_part .swiper-slide-active").find("img");
      imgs.each(function() {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");
        $(".sp_product_part").append(flyer);
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",
          top: $img[0].offsetTop,
          left: $img.offset().left,
          "z-index": 99
        });
        let finish;
        if (document.body.clientWidth <= 1080) {
          finish = $(".sp-btn-style2 .sp-cart");
          $(flyer).animate(
            {
              top: $(".sp-btn-style2")[0].offsetTop,
              left: $(".sp-btn-style2 .sp-area2")[0].offsetLeft + finish.width() / 2,
              width: 50,
              height: 50,
              opacity: 0.4
            },
            500,
            "linear",
            function() {
              $(this).animate(
                {
                  width: 0,
                  height: 0,
                  opacity: 0
                },
                0,
                function() {
                  $(this).detach();
                }
              );
            }
          );
        } else {
          finish = $(".sp_pc .sp-cart");
          $(flyer).animate(
            {
              top: finish[0].offsetTop,
              left: finish[0].offsetLeft + finish.width() / 2,
              width: 50,
              height: 50,
              opacity: 0.4
            },
            500,
            "linear",
            function() {
              $(this).animate(
                {
                  width: 0,
                  height: 0,
                  opacity: 0
                },
                0,
                function() {
                  $(this).detach();
                }
              );
            }
          );
        }
      });
    });
    $(".sp-qa3-question").on("click", function() {
      var $currentItem = $(this).closest(".sp-qa3-item");
      var $answer = $currentItem.find(".sp-qa3-answer");
      if ($currentItem.hasClass("active")) {
        $answer.slideUp(300);
        $currentItem.removeClass("active");
      } else {
        $(".sp-qa3-item").removeClass("active");
        $(".sp-qa3-answer").slideUp(300);
        $currentItem.addClass("active");
        $answer.slideDown(300);
      }
    });
    const graduallyList2 = document.getElementsByClassName("sp-fade-box");
    for (let gradually2 of graduallyList2) {
      const paragraph2 = gradually2.querySelectorAll(".sp-ani");
      const observerAni = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              paragraph2.forEach((span, index) => {
                span.style.animation = `sp-fade-in 1s ease forwards`;
                span.style.animationDelay = `${index * 0.5 + 0.5}s`;
              });
              observerAni.unobserve(gradually2);
            }
          });
        },
        {
          threshold: 0.3
        }
      );
      observerAni.observe(gradually2);
    }
    const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
    for (let gradually3 of graduallyList3) {
      const paragraph3 = gradually3.querySelectorAll(".sp-ani2");
      const observerAni = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              paragraph3.forEach((span, index) => {
                span.style.animation = `sp-fade-left 1s ease forwards`;
                span.style.animationDelay = `${index * 0.3 + 1}s`;
              });
              observerAni.unobserve(gradually3);
            }
          });
        },
        {
          threshold: 0.3
        }
      );
      observerAni.observe(gradually3);
    }
  });
})(jQuery);
